/**
 * Names on the Splits tab. Runs record who queued them as `"Name (member no)"` (the audit-trail
 * actor string), which is right for history and too long for a chip.
 */

/** "Dipal Patel (t1225)" -> "Dipal Patel". The member number is the identity; the name is for people. */
export function shortName(actor: string | null | undefined): string {
  if (!actor) return "unknown";
  return actor.replace(/\s*\([^)]*\)\s*$/, "").trim() || actor;
}

/** Who to show: "you" for the viewer's own run, otherwise the name. */
export function whoLabel(actor: string | null | undefined, isMine: boolean): string {
  return isMine ? "you" : shortName(actor);
}
